export default "__VITE_ASSET__CtId6yE3__"